import algoliasearch from 'algoliasearch'

const applicationID = 'HGNJ6RXCOS'
const apiKey = '4cfb4007b71999442efc9800088f9fcb'

export const client = algoliasearch(applicationID, apiKey)

export const eventIndex = client.initIndex('events')
export const orgIndex = client.initIndex('organizations')
